import {
  MarketSpotlightLayoutGetRequestType,
  MarketSpotlightLayoutGetResponseType,
} from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptions,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useMarketSpotlightPageLayout = <
  TData = MarketSpotlightLayoutGetResponseType,
>(
  params: MarketSpotlightLayoutGetRequestType,
  options?: ApiV2QueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [user?.uid, business?.id, ServerStateKeys.StorefrontLink, params],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `market-spotlight-layout`,
        params,
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultQueryOptions(options),
  });
};
